var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[_c('TheHeader'),_c('router-view',{key:_vm.$route.fullPath}),(_vm.isValidRoute)?_c('div',{key:_vm.increment},[_c('v-container',[_c('BannerAdvert')],1)],1):_vm._e()],1),_c('TheFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }